import React, { useMemo, useState } from "react";
import "./styles.css";
import { colors } from "theme";
import { BaseDropdown, BaseInput, Ptag } from "components/core";
import GradeAccordion from "./GradeAccordion";
import DependentsCard from "./DependentsCard";
import { Field } from "formik";

const FORMIK_MATERNITY = [
  "maternity_delivery_coverage_limit",
  "maternity_delivery_coverage_limit_min",
  "maternity_delivery_coverage_limit_max",
  "maternity_delivery_coverage_limit_normal_max",
  "maternity_delivery_coverage_limit_icu_max",
  "maternity_delivery_coverage_remarks",
  "maternity_new_born_cover_limit",
  "maternity_new_born_cover_remarks",
  "maternity_natal_cover_limit",
  "maternity_natal_cover_remarks",
  "maternity_metro_toggler",
  "metro_maternity_delivery_coverage_limit_normal",
  "metro_maternity_delivery_coverage_limit_caeserian",
  "metro_maternity_delivery_coverage_remarks",
  "metro_maternity_new_born_cover_limit",
  "metro_maternity_new_born_cover_remarks",
  "metro_maternity_natal_cover_limit",
  "metro_maternity_natal_cover_remarks",
  "non_metro_maternity_delivery_coverage_limit_normal",
  "non_metro_maternity_delivery_coverage_limit_caeserian",
  "non_metro_maternity_delivery_coverage_remarks",
  "non_metro_maternity_new_born_cover_limit",
  "non_metro_maternity_new_born_cover_remarks",
  "non_metro_maternity_natal_cover_limit",
  "non_metro_maternity_natal_cover_remarks",
];


const GradeMaternity = ({ formikProps, attribute, toggleHandler, onToggleChange }) => {
  const doesValueExist = useMemo(() => {
    const values = formikProps.values;
    return FORMIK_MATERNITY.some(key => values[key]);
  }, [formikProps]);

  // Console log formik errors for debugging
  console.log("GradeMaternity - formikProps.errors:", formikProps.errors);
  console.log("GradeMaternity - formikProps.values:", formikProps.values);
  console.log("GradeMaternity - toggleStatus:", formikProps.values.maternity_metro_toggler);
  console.log("GradeMaternity - attribute:", attribute);
  
  // Log specific metro/non-metro field values
  console.log("GradeMaternity - Metro/Non-Metro field values:", {
    metro_normal: formikProps.values.metro_maternity_delivery_coverage_limit_normal,
    metro_caeserian: formikProps.values.metro_maternity_delivery_coverage_limit_caeserian,
    non_metro_normal: formikProps.values.non_metro_maternity_delivery_coverage_limit_normal,
    non_metro_caeserian: formikProps.values.non_metro_maternity_delivery_coverage_limit_caeserian
  });

  let selectedDetails = localStorage.getItem("eb_selected_values");
  if (selectedDetails) {
    selectedDetails = JSON.parse(selectedDetails);
  }

  const isFlex = useMemo(() => {
    return selectedDetails?.flex;
  }, [selectedDetails]);

  const initalToggleStatus = useMemo(() => {
    let status = false;
    if (!attribute?.toggle) {
      status = true;
    }
    if (doesValueExist) status = true;
    return status;
  }, [attribute, doesValueExist]);

  const [toggleStatus, setToggleStatus] = useState(initalToggleStatus);
  const doesRangeExist = useMemo(() => {
    return attribute.selectable_values.length > 0;
  }, [attribute]);

  const options = useMemo(() => {
    const selectables = attribute.selectable_values.find(
      (attr) => attr["Delivery Coverage"]
    );
    if (!selectables) return [];
    if (Array.isArray(selectables?.["Delivery Coverage"])) {
      return selectables["Delivery Coverage"].map((val) => ({
        label: val,
        value: val,
      }));
    } else {
      return [
        {
          label: selectables?.["Delivery Coverage"],
          value: selectables?.["Delivery Coverage"],
        },
      ];
    }
  }, [attribute]);

  // Console log options after they're defined
  console.log("GradeMaternity - options:", options);
  console.log("GradeMaternity - options.length:", options.length);

  const interstitialToggler = (bool) => {
    setToggleStatus(bool);
    if (!bool) {
      FORMIK_MATERNITY.forEach(key => {
        formikProps.setFieldValue(key, "", true);
      });
    }
    toggleHandler &&
      toggleHandler(bool, attribute?.attribute_data?.attribute_name);
    
    // Notify parent component about toggle change
    onToggleChange && onToggleChange(bool);
  };

  const renderMetroNonMetro = (type) => {
    const title = type === "metro" ? "Metro Cities" : "Non-Metro Cities";

    return (
      <div className="grade-summary-inner">
        <Ptag
          fontSize="18px"
          fontWeight="500"
          marginBottom="24px"
          marginTop="16px"
          fontFamily="Montserrat"
        >
          {title}
        </Ptag>
        <section
          className="field-card"
          style={{
            backgroundColor: "white",
          }}
        >
          <Ptag
            fontSize="16px"
            marginBottom="10px"
            fontWeight="600"
            color="#6041BA"
            fontFamily="Montserrat"
          >
            Delivery Coverage
          </Ptag>
          <div className="sum-insured-container">
            <BaseInput
              staticLabel="Limit for Normal Delivery"
              disabled={!toggleStatus}
              fontSize="16px !important"
              type="text"
              formikProps={{
                ...formikProps,
                name: `${type}_maternity_delivery_coverage_limit_normal`,
              }}
            />
            {/* No individual field errors - using attention banner approach */}
            <BaseInput
              staticLabel="Limit for Cesarean"
              disabled={!toggleStatus}
              fontSize="16px !important"
              type="text"
              formikProps={{
                ...formikProps,
                name: `${type}_maternity_delivery_coverage_limit_caeserian`,
              }}
            />
            {/* No individual field errors - using attention banner approach */}
          </div>
          <div
            style={{
              marginTop: "16px",
            }}
          >
            <BaseInput
              staticLabel="Remarks (optional)"
              type="text"
              fontSize="16px !important"
              disabled={!toggleStatus}
              formikProps={{
                ...formikProps,
                name: `${type}_maternity_delivery_coverage_remarks`,
              }}
            />
          </div>
        </section>
        <div
          className="field-card"
          style={{
            marginTop: "3rem",
            backgroundColor: "white",
          }}
        >
          <Ptag
            fontSize="16px"
            marginBottom="20px"
            fontWeight="600"
            color="#6041BA"
            fontFamily="Montserrat"
          >
            New Born Cover
          </Ptag>
          <BaseInput
            staticLabel="Limit (optional)"
            type="text"
            fontSize="16px !important"
            disabled={!toggleStatus}
            formikProps={{
              ...formikProps,
              name: `${type}_maternity_new_born_cover_limit`,
            }}
          />
          <div
            style={{
              marginTop: "16px",
            }}
          >
            <BaseInput
              staticLabel="Remarks (optional)"
              type="text"
              fontSize="16px !important"
              disabled={!toggleStatus}
              formikProps={{
                ...formikProps,
                name: `${type}_maternity_new_born_cover_remarks`,
              }}
            />
          </div>
        </div>
        <div
          className="field-card"
          style={{
            marginTop: "3rem",
            backgroundColor: "white",
          }}
        >
          <Ptag
            fontSize="16px"
            fontWeight="600"
            marginBottom="20px"
            color="#6041BA"
            fontFamily="Montserrat"
          >
            Pre/Post Natal Cover
          </Ptag>
          <BaseInput
            staticLabel="Limit (optional)"
            type="text"
            fontSize="16px !important"
            disabled={!toggleStatus}
            formikProps={{
              ...formikProps,
              name: `${type}_maternity_natal_cover_limit`,
            }}
          />
          <div
            style={{
              marginTop: "16px",
            }}
          >
            <BaseInput
              staticLabel="Remarks (optional)"
              type="text"
              fontSize="16px !important"
              disabled={!toggleStatus}
              formikProps={{
                ...formikProps,
                name: `${type}_maternity_natal_cover_remarks`,
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  const handleMetroToggle = (value, onChange) => {
    if (!toggleStatus) return;
    formikProps.setFieldValue("maternity_metro_toggler", !value);
  };

  return attribute ? (
    <GradeAccordion
      title="Maternity Coverage"
      showSwitch={attribute?.toggle}
      canSelect={toggleStatus}
      setToggleStatus={interstitialToggler}
      expanded={toggleStatus}
    >
      <section>
        {options.length === 0 ? (
          <div
            style={{
              maxWidth: "300px",
              marginBottom: "24px",
            }}
          >
            <Field name="maternity_metro_toggler">
              {({
                field, // { name, value, onChange, onBlur }
              }) => (
                <DependentsCard
                  handleClick={() =>
                    handleMetroToggle(field.value, field.onChange)
                  }
                  selected={field.value}
                >
                  <Ptag fontFamily="Montserrat">
                    Split Coverage by Metro/ Non-Metro
                  </Ptag>

                </DependentsCard>
              )}
            </Field>
          </div>
        ) : null}
        {formikProps.values.maternity_metro_toggler ? (
          <>
            {renderMetroNonMetro("metro")}
            {renderMetroNonMetro("non_metro")}
          </>
        ) : (
          <>
            <section className="field-card">
              <Ptag
                fontSize="16px"
                marginBottom="20px"
                fontWeight="600"
                color="#6041BA"
              >
                Delivery Coverage
              </Ptag>
              <div className="sum-insured-container">
                {options.length !== 0 && (doesRangeExist ? (
                  <BaseDropdown
                    fontSize="16"
                    staticLabel="Limit"
                    options={options}
                    disabled={!toggleStatus}
                    formikProps={{
                      ...formikProps,
                      name: "maternity_delivery_coverage_limit",
                    }}
                  />
                ) : (
                  <BaseInput
                    staticLabel="Limit"
                    disabled={!toggleStatus}
                    fontSize="16px !important"
                    type="number"
                    formikProps={{
                      ...formikProps,
                      name: "maternity_delivery_coverage_limit",
                    }}
                  />
                ))}
                {/* No error display in default mode - errors only show for non-metro cities */}
                {doesRangeExist && isFlex && (
                  <div>
                    <Ptag
                      color={colors.primaryColor}
                      fontSize="14px"
                      marginBottom="10px"
                    >
                      Range
                    </Ptag>
                    <div className="sum-insured-container">
                      <BaseDropdown
                        fontSize="16"
                        label="Min"
                        options={options}
                        disabled={!toggleStatus}
                        formikProps={{
                          ...formikProps,
                          name: "maternity_delivery_coverage_limit_min",
                        }}
                      />
                      <BaseDropdown
                        fontSize="16"
                        label="Max"
                        options={options}
                        disabled={!toggleStatus}
                        formikProps={{
                          ...formikProps,
                          name: "maternity_delivery_coverage_limit_max",
                        }}
                      />
                    </div>
                    {/* Error display for Min/Max fields */}
                    {(formikProps.errors.maternity_delivery_coverage_limit_min || formikProps.errors.maternity_delivery_coverage_limit_max) && (
                      <Ptag
                        color="#d32f2f"
                        fontSize="12px"
                        fontWeight="500"
                        style={{ marginTop: "4px", marginLeft: "16px" }}
                      >
                        *Required
                      </Ptag>
                    )}
                  </div>
                )}
              </div>
              <div
                className="sum-insured-container"
                style={{
                }}
              >
                <BaseInput
                  staticLabel={options.length === 0 ? 'Limit for Normal Delivery' : "Max per day limit for Normal Delivery (optional)"}
                  type="text"
                  
                  fontSize="16px !important"
                  disabled={!toggleStatus}
                  formikProps={{
                    ...formikProps,
                    name: "maternity_delivery_coverage_limit_normal_max",
                  }}
                />
                {/* No individual field errors - using attention banner approach */}
           
                <BaseInput
                  staticLabel={options.length === 0 ? 'Limit for Cesarean' : "Max per day limit for Cesarean (optional)"}
                  type="text"
                  fontSize="16px !important"
                  disabled={!toggleStatus}
                  formikProps={{
                    ...formikProps,
                    name: "maternity_delivery_coverage_limit_icu_max",
                  }}
                />
                {/* Error display for Cesarean - only when required (options.length === 0) */}
                {(() => {
                  const hasError = formikProps.errors["maternity_delivery_coverage_limit_icu_max"];
                  const shouldShow = options.length === 0 && hasError;
                  console.log("Cesarean Error Check:", {
                    hasError,
                    shouldShow,
                    optionsLength: options.length,
                    errorValue: formikProps.errors["maternity_delivery_coverage_limit_icu_max"]
                  });
                  return shouldShow;
                })() && (
                  <Ptag
                    color="#d32f2f"
                    fontSize="12px"
                    fontWeight="500"
                    style={{ marginTop: "4px", marginLeft: "16px", marginBottom: "8px" }}
                  >
                    *Required
                  </Ptag>
                )}
              </div>
              <div
                style={{
                  marginTop: "16px",
                }}
              >
                <BaseInput
                  staticLabel="Remarks (optional)"
                  type="text"
                  fontSize="16px !important"
                  disabled={!toggleStatus}
                  formikProps={{
                    ...formikProps,
                    name: "maternity_delivery_coverage_remarks",
                  }}
                />
              </div>
            </section>
            <div
              className="field-card"
              style={{
                marginTop: "3rem",
              }}
            >
              <Ptag
                fontSize="16px"
                marginBottom="20px"
                fontWeight="600"
                color="#6041BA"
              >
                New Born Cover
              </Ptag>
              <BaseInput
                staticLabel="Limit (optional)"
                type="text"
                fontSize="16px !important"
                disabled={!toggleStatus}
                formikProps={{
                  ...formikProps,
                  name: "maternity_new_born_cover_limit",
                }}
              />
              <div
                style={{
                  marginTop: "16px",
                }}
              >
                <BaseInput
                  staticLabel="Remarks (optional)"
                  type="text"
                  fontSize="16px !important"
                  disabled={!toggleStatus}
                  formikProps={{
                    ...formikProps,
                    name: "maternity_new_born_cover_remarks",
                  }}
                />
              </div>
            </div>
            <div
              className="field-card"
              style={{
                marginTop: "3rem",
              }}
            >
              <Ptag
                fontSize="16px"
                fontWeight="600"
                marginBottom="20px"
                color="#6041BA"
              >
                Pre/Post Natal Cover
              </Ptag>
              <BaseInput
                staticLabel="Limit (optional)"
                type="text"
                fontSize="16px !important"
                disabled={!toggleStatus}
                formikProps={{
                  ...formikProps,
                  name: "maternity_natal_cover_limit",
                }}
              />
              <div
                style={{
                  marginTop: "16px",
                }}
              >
                <BaseInput
                  staticLabel="Remarks (optional)"
                  type="text"
                  fontSize="16px !important"
                  disabled={!toggleStatus}
                  formikProps={{
                    ...formikProps,
                    name: "maternity_natal_cover_remarks",
                  }}
                />
              </div>
            </div>
          </>
        )}
      </section>
    </GradeAccordion>
  ) : null;
};

export default GradeMaternity;
